/**
 * One glyph per content format, shared by the card badge and the library's format
 * filter: the glyph a member taps to filter should be the one they then see on the
 * tiles. Kept out of `FormatBadge.tsx` so that file exports only its component.
 */

import type { SvgIconComponent } from "@mui/icons-material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ChecklistRtlOutlinedIcon from "@mui/icons-material/ChecklistRtlOutlined";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";

import type { ContentFormat } from "~/types/news";

export const FORMAT_ICONS: Record<ContentFormat, SvgIconComponent> = {
  clanek: ArticleOutlinedIcon,
  video: PlayArrowRoundedIcon,
  protokol: ChecklistRtlOutlinedIcon,
  "zaznam-webinare": VideocamOutlinedIcon,
};
